module.exports = __webpack_public_path__ + "static/media/Sec-2_2677_Icon_1_CN.84973192.png";